import "./bottombanner.css";

function BottomBanner() {
  return (

        <section id="cta-1071">
            <div className="cs-container">
                <div className="cs-content">
                    <div className="cs-flex">
                        <span className="cs-topper">First step in the spiritual effort</span>
                        <h2 className="cs-title">Only steady effort will bring success!</h2>
                    </div>
                    <div className="cs-button-box">
                        <a href="/service" className="cs-button-solid">Learn About Service Opportunities</a>
                        <a href="/sse" className="cs-button-transparent">Sai Spiritual Education</a>
                    </div>
                </div>
            </div>
            <picture className="cs-background">
                <source media="(max-width: 600px)" srcSet="/images/help-ever.png"></source>
                <source media="(min-width: 601px)" srcSet="/images/help-ever.png"></source>
                <img loading="lazy" decoding="async" src="/images/help-ever.png" alt="Help Ever" width="1280" height="568"></img>
            </picture>
        </section>
    );
}

export default BottomBanner;